// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Activity from "./activity.js"

const modelClassData = {
  "attributes": {
    "activity_id": {
      "column": {
        "default": null,
        "name": "activity_id",
        "null": false,
        "type": "uuid"
      },
      "name": "activity_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "max_number_of_students": {
      "column": {
        "default": null,
        "name": "max_number_of_students",
        "null": false,
        "type": "integer"
      },
      "name": "max_number_of_students",
      "selected_by_default": null,
      "translated": null
    },
    "min_number_of_students": {
      "column": {
        "default": null,
        "name": "min_number_of_students",
        "null": false,
        "type": "integer"
      },
      "name": "min_number_of_students",
      "selected_by_default": null,
      "translated": null
    },
    "number_of_students": {
      "column": {
        "default": null,
        "name": "number_of_students",
        "null": false,
        "type": "integer"
      },
      "name": "number_of_students",
      "selected_by_default": null,
      "translated": null
    },
    "participant_type": {
      "column": {
        "default": null,
        "name": "participant_type",
        "null": false,
        "type": "string"
      },
      "name": "participant_type",
      "selected_by_default": null,
      "translated": null
    },
    "translated_participant_type": {
      "column": null,
      "name": "translated_participant_type",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ActivityParticipantTypeRule",
  "collectionKey": "activity_participant_type_rules",
  "collectionName": "activity_participant_type_rules",
  "i18nKey": "activity_participant_type_rule",
  "camelizedLower": "activityParticipantTypeRule",
  "name": "ActivityParticipantTypeRule",
  "nameDasherized": "activity-participant-type-rule",
  "pluralName": "activity_participant_type_rules",
  "ransackable_associations": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "belongs_to",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "activity_id",
      "column": {
        "default": null,
        "name": "activity_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "max_number_of_students",
      "column": {
        "default": null,
        "name": "max_number_of_students",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "min_number_of_students",
      "column": {
        "default": null,
        "name": "min_number_of_students",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "number_of_students",
      "column": {
        "default": null,
        "name": "number_of_students",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "old_activity_id",
      "column": {
        "default": null,
        "name": "old_activity_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "participant_type",
      "column": {
        "default": null,
        "name": "participant_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "belongs_to",
      "resource_name": "Activity",
      "through": null
    }
  ],
  "paramKey": "activity_participant_type_rule",
  "primaryKey": "id"
}

/** Frontend model for ActivityParticipantTypeRule. */
export default class ActivityParticipantTypeRule extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  activityId() {
    return this.readAttributeUnderscore("activity_id")
  }

  /** @returns {boolean} */
  hasActivityId() {
    const value = this.activityId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number} */
  maxNumberOfStudents() {
    return this.readAttributeUnderscore("max_number_of_students")
  }

  /** @returns {boolean} */
  hasMaxNumberOfStudents() {
    const value = this.maxNumberOfStudents()

    return this._isPresent(value)
  }

  /** @returns {number} */
  minNumberOfStudents() {
    return this.readAttributeUnderscore("min_number_of_students")
  }

  /** @returns {boolean} */
  hasMinNumberOfStudents() {
    const value = this.minNumberOfStudents()

    return this._isPresent(value)
  }

  /** @returns {number} */
  numberOfStudents() {
    return this.readAttributeUnderscore("number_of_students")
  }

  /** @returns {boolean} */
  hasNumberOfStudents() {
    const value = this.numberOfStudents()

    return this._isPresent(value)
  }

  /** @returns {string} */
  participantType() {
    return this.readAttributeUnderscore("participant_type")
  }

  /** @returns {boolean} */
  hasParticipantType() {
    const value = this.participantType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedParticipantType() {
    return this.readAttributeUnderscore("translated_participant_type")
  }

  /** @returns {boolean} */
  hasTranslatedParticipantType() {
    const value = this.translatedParticipantType()

    return this._isPresent(value)
  }

  /** @returns {import("./activity.js").default | null} */
  activity() {
    return this._readBelongsToReflection({modelClass: Activity, reflectionName: "activity"})
  }

  /** @returns {Promise<import("./activity.js").default | null>} */
  loadActivity() {
    if (!("activityId" in this)) throw new Error("Foreign key method wasn't defined: activityId")

    const id = this.activityId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "activity",
        model: this,
        modelClass: Activity
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./activity.js").default | null>} */
  ensureActivityLoaded() {
    return this.ensureAssociationLoaded("activity")
  }
}
